/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeADownIcon16Light } from './ArrowShapeADownIcon16Light';
import { ArrowShapeADownIcon16Regular } from './ArrowShapeADownIcon16Regular';
import { ArrowShapeADownIcon16Solid } from './ArrowShapeADownIcon16Solid';
import { ArrowShapeADownIcon20Light } from './ArrowShapeADownIcon20Light';
import { ArrowShapeADownIcon20Regular } from './ArrowShapeADownIcon20Regular';
import { ArrowShapeADownIcon20Solid } from './ArrowShapeADownIcon20Solid';
import { ArrowShapeADownIcon24Regular } from './ArrowShapeADownIcon24Regular';
import { ArrowShapeADownIcon24Solid } from './ArrowShapeADownIcon24Solid';
import { ArrowShapeADownIcon32Regular } from './ArrowShapeADownIcon32Regular';
import { ArrowShapeADownIcon64Regular } from './ArrowShapeADownIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeADownIcon16Light,
        regular: ArrowShapeADownIcon16Regular,
        solid: ArrowShapeADownIcon16Solid,
    },
    20: {
        light: ArrowShapeADownIcon20Light,
        regular: ArrowShapeADownIcon20Regular,
        solid: ArrowShapeADownIcon20Solid,
    },
    24: {
        regular: ArrowShapeADownIcon24Regular,
        solid: ArrowShapeADownIcon24Solid,
    },
    32: {
        regular: ArrowShapeADownIcon32Regular,
    },
    64: {
        regular: ArrowShapeADownIcon64Regular,
    },
};
export var ArrowShapeADownIcon = forwardRef('ArrowShapeADownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
